import env from "src/core/env";
import { AxiosRequestConfig } from "axios";
import { Api } from "src/core/api";

export abstract class Repository<
  Request = any,
  Response = any,
  ListRequest = any,
  ListResponse = any
> {
  protected basePath = "";
  protected apiUrl: string;
  protected api: Api;

  constructor(apiUrl?: string, token_type?: TokenTypes) {
    this.apiUrl = apiUrl || env.API_URL;
    this.api = new Api(this.apiUrl);
    if (token_type) {
      this.api.setAuthorizationTokenType(token_type);
    }
  }

  public create(data: Request) {
    return this.api.post(this.basePath, data);
  }

  public update(id: string | number, data: Request) {
    return this.api.put(this.basePath, { id, ...data });
  }

  public multipartCreate(data: Request) {
    return this.api.multipartPost(this.basePath, data);
  }

  public multipartUpdate(id: string, data: Request) {
    return this.api.multipartPut(this.basePath, { id, ...data });
  }

  public getOne(id: number | string) {
    return this.api.get<Response>(this.basePath + "/" + id);
  }

  public get(params?: ListRequest) {
    return this.api.get<ListResponse>(this.basePath + "/all", params);
  }

  public delete(id: number | string) {
    return this.api.delete(this.basePath + "/" + id);
  }

  public request<Response = any>(config: AxiosRequestConfig) {
    return this.api.request<Response>({
      ...config,
      url: this.basePath + config.url,
    });
  }
}
